(function(){
'use strict';

scStripeService.$inject = ["cpAPI", "scCurrencyService"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @kind service
 * @name scStripeService
 *
 * @description
 * Handles Stripe tings
 */

function scStripeService(cpAPI, scCurrencyService) {
  this.loaded = false;

  this.updatePaymentRequest = function () {
    return false;
  };

  this.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _this = this;

    var publishableKey;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!this.loaded) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            publishableKey = SC.stripe.stripe_publishable_key;

            if (!(typeof Stripe === 'undefined')) {
              _context.next = 6;
              break;
            }

            _context.next = 6;
            return loadScript('https://js.stripe.com/v3/');

          case 6:

            this.stripe = Stripe(publishableKey);

            this.createPaymentRequest = function (_ref2, submitCallback) {
              var country = _ref2.country,
                  currency = _ref2.currency,
                  label = _ref2.label,
                  amount = _ref2.amount;

              _this.paymentRequest = _this.stripe.paymentRequest(_this.createPaymentRequestProps({ country: country, currency: currency, label: label, amount: amount }));

              _this.paymentRequest.on('paymentmethod', submitCallback);

              _this.canMakePayment = _this.paymentRequest.canMakePayment;
            };

            this.createPaymentRequestProps = function (_ref3) {
              var country = _ref3.country,
                  currency = _ref3.currency,
                  label = _ref3.label,
                  amount = _ref3.amount;
              return {
                country: country,
                currency: currency,
                total: {
                  label: label,
                  amount: getStripeAmount(amount, currency)
                },
                requestPayerName: true,
                requestPayerEmail: true,
                disableWallets: ['link']
              };
            };

            this.updatePaymentRequest = function (_ref4) {
              var amount = _ref4.amount,
                  label = _ref4.label,
                  currency = _ref4.currency;

              if (_this.paymentRequest === undefined) {
                return;
              }
              _this.paymentRequest.update({
                currency: currency,
                total: {
                  label: label,
                  amount: getStripeAmount(amount, currency)
                }
              });
            };

            this.loaded = true;

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  /**
   * getStripePublishableKey
   *
   * Gets the correct publishable key for the stripe elements depending on the pay
   * api we are interacting with (production vs. no-prod environments). This makes it easier
   * on the client so they don't need to keep track of a bunch of pay-related credentials.
   *
   * @return Promise - resolves to publishable key
   */
  // eslint-disable-next-line no-unused-vars
  var getStripePublishableKey = function getStripePublishableKey() {
    return cpAPI.getStripePublishableKey().catch(function (err) {
      console.log('Error retrieving stripe publishable key:', err); // eslint-disable-line no-console
      bugsnagClient.notify(new Error('Error retrieving stripe publishable key', { cause: err }));
    });
  };

  var getStripeAmount = function getStripeAmount(amount, currency) {
    return parseInt((amount * nonDecimalizer(currency)).toFixed(), 10);
  };

  var nonDecimalizer = function nonDecimalizer(currency) {
    return Math.pow(10, scCurrencyService.getAllowedDecimals(currency.toUpperCase()));
  };

  var loadScript = function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      var r = false;
      s.type = 'text/javascript';
      s.src = src;
      s.async = true;
      s.onerror = function (err) {
        reject(err, s);
      };
      // eslint-disable-next-line no-multi-assign
      s.onload = s.onreadystatechange = function () {
        if (!r && (!this.readyState || this.readyState == 'complete')) {
          r = true;
          resolve();
        }
      };
      var t = document.getElementsByTagName('script')[0];
      t.parentElement.insertBefore(s, t);
    });
  };
}

angular.module('classy').service('scStripeService', scStripeService);
})();